// @ngInject
function stateConfig($stateProvider) {
    $stateProvider.state('product.brands', {
        url: '/brands?searchTerm',
        views: {'productList@product': {
            templateUrl: 'main/product/brands/brands.tpl.html',
            controller: 'BrandsController as vm'
        }},
        resolve: {
            brands: brandsResolver,
            searchTerm: searchTermesolver
        }
    });
}

// @ngInject
function brandsResolver(BrandsApiService,$stateParams) {
    return BrandsApiService.getBrands({page: 0, searchTerm: $stateParams.searchTerm, pageSize: null});
}

// @ngInject
function searchTermesolver($stateParams) {
    return $stateParams.searchTerm;
}

// @ngInject
function BrandsController($rootScope, $state, $scope, brands, BrandsApiService,loadSpinnerService,searchTerm) {
    var vm = this;

    vm.currentUser = $rootScope.currentUser;

    vm.brands = brands;
    vm.selectedBrandId = 0;
    vm.searchTerm = (searchTerm) ? searchTerm : '';
    vm.currentPage = 1;
    vm.itemsPerPage = null;
    vm.sortingKey = '';
    vm.sortingDesc = false;

    vm.searchTermChange = searchTermChange;
    vm.sortBrands = sortBrands;
    activate();

    function activate() {
        $scope.$watch(function() { return $state.params.brandId; }, function(newValue, oldValue) {
            vm.selectedBrandId = parseInt($state.params.brandId, 10);
        });
        $rootScope.$on('Brand.Inserted', function(event, response) {
        });
        $rootScope.$on('Brand.Updated', function(event, response) {
        });
        $rootScope.$on('Brand.Deleted', function(event, response) {
        });
        $rootScope.$on('Brand.Changed', function(event, response) {
            loadBrands();
        });
    }

    function loadBrands() {
        loadSpinnerService.start('mainSpinner');
        BrandsApiService.getBrands({page: vm.currentPage - 1, searchTerm: vm.searchTerm, sortingKey: vm.sortingKey, sortingDesc: vm.sortingDesc, pageSize: vm.itemsPerPage}).then(function(response) {
            vm.brands = response;
        }).finally(function () {
            loadSpinnerService.stop('mainSpinner',{force: true});
        });
    }

    function searchTermChange() {
        vm.currentPage = 1;
        loadBrands();
    }

    function sortBrands(sortingKey){
        vm.sortingKey = sortingKey;
        vm.sortingDesc = !vm.sortingDesc;
        loadBrands();
    }

}

angular
    .module('product.brands', ['brands.api','brands.brand'])
    .config(stateConfig)
    .controller('BrandsController', BrandsController);
